import { fetchUserCode } from '@/api/credentials-api';
import React, { useEffect, useState } from 'react';

interface UserLink {
  name: string;
  role: string;
  userId: string;
  code?: string;
}

const userLinks: UserLink[] = [
  { name: 'Dimple Beltran', role: 'OIC', userId: '6620' },
  { name: 'Jene Fabiano', role: 'BM', userId: '6618' },
  { name: 'Jan Aron Nabus', role: 'AC', userId: '10912' },
  { name: 'Guliver Riveta', role: 'AC', userId: '10911' },
  { name: 'Joemark Jacinto', role: 'AC', userId: '10910' },
  { name: 'Ivan Zapanta', role: 'AC', userId: '11427' },
  { name: 'John Nino Salimbao', role: 'AC', userId: '13027' },
  { name: 'Geraldine Loise Cansino', role: 'AC', userId: '13182' },
  { name: 'John Rhod Lumabi', role: 'AC', userId: '13375' },
  { name: 'Francis Ian Alferez', role: 'AC', userId: '10913' },
  { name: 'Jan Paul Zerna', role: 'AC', userId: '10915' },
  { name: 'Eubert Germina', role: 'AC', userId: '15190' },
  { name: 'Edison Fernando', role: 'ME', userId: '13220' },
  { name: 'Frietzie Lian Lecreo', role: 'ME', userId: '16061' },
  { name: 'Annaliza Lacsamana', role: 'ME', userId: '1246' },
  { name: 'Nicole Sabas', role: 'MA', userId: '11732' },
  { name: 'Jacqueline Tabil', role: 'MA', userId: '13029' },
  { name: 'Calixtro Rosales Jr', role: 'DNDPA', userId: '11740' },
  { name: 'Ellen Nalupa', role: 'DNDPA', userId: '13030' },
  { name: 'Daniela Cabadsan', role: 'DNDM', userId: '13322' },
  { name: 'Karen Grace Molato Tejano', role: 'DNDM', userId: '11865' },
  { name: 'Aaron Steven Aramil', role: 'SAS', userId: '10925' },
  { name: 'Jonanchekar Cubillas', role: 'SAS', userId: '11465' },
  { name: 'Bryan Brin', role: 'DNDM', userId: '10926' },
  { name: 'Christian Davila', role: 'SNS', userId: '13379' },
  { name: 'Bryan Carlo Brazula', role: 'DM', userId: '13434' },
  { name: 'Gilbert De Guzman', role: 'AS', userId: '6258' },
  { name: 'Mary Claur Sacaben', role: 'AS', userId: '10927' },
  { name: 'Christian Joshua Libatique', role: 'GAPS', userId: '11929' },
  { name: 'Norvin Barcelon', role: 'GAPS', userId: '13877' },
  { name: 'Manuelito Nemis', role: 'GAPSV', userId: '15459' },
  { name: 'Jo Alan Brudo', role: 'GAPSV', userId: '5752' },
  { name: 'Al Joone Rosario', role: 'GAM', userId: '15460' },
  { name: 'Christian Gojo', role: 'GAM', userId: '13323' },
  { name: 'Kent Torno', role: 'SA', userId: '23' },
  { name: 'Clark Kent', role: 'MH', userId: '1' },
  { name: 'Ann Nicole Mae Ang', role: 'MH', userId: '17650' },
  { name: 'Rodel Marc Gionggo', role: 'AC', userId: '17651' },
  { name: 'John Eric Catalan', role: 'AC', userId: '17652' },
  { name: 'Joshua Bolocon', role: 'AC', userId: '17653' }
]

const roleColors: Record<string, string> = {
  OIC: 'bg-blue-200 text-blue-800',
  BM: 'bg-green-200 text-green-800',
  AC: 'bg-yellow-200 text-yellow-800',
  ME: 'bg-purple-200 text-purple-800',
  MA: 'bg-pink-200 text-pink-800',
  DNDPA: 'bg-indigo-200 text-indigo-800',
  DNDM: 'bg-red-200 text-red-800',
  SAS: 'bg-teal-200 text-teal-800',
  SNS: 'bg-orange-200 text-orange-800',
  DM: 'bg-gray-200 text-gray-800',
  AS: 'bg-cyan-200 text-cyan-800',
  GAPS: 'bg-lime-200 text-lime-800',
  GAPSV: 'bg-rose-200 text-rose-800',
  GAM: 'bg-fuchsia-200 text-fuchsia-800',
  SA: 'bg-stone-200 text-stone-800',
  MH: 'bg-amber-200 text-amber-800',
};

export const Credentials: React.FC = () => {
  const [users, setUsers] = useState<UserLink[]>(userLinks)
  const [loading, setLoading] = useState<boolean>(true)
  const [error, setError] = useState<string | null>(null)
  const baseUrl = window.location.origin;

  useEffect(() => {
    const fetchAllCodes = async () => {
      try {
        setLoading(true)

        const userPromises = userLinks.map(async (user) => {
          try {
            const code = await fetchUserCode(user.userId)
            return { ...user, code }
          } catch (err) {
            return { ...user, code: 'ERROR' }
          }
        })

        const usersWithCodes = await Promise.all(userPromises)
        setUsers(usersWithCodes)
        setError(null)
      } catch (err) {
        setError('Failed to load some credentials. Please refresh page.')
      } finally {
        setLoading(false)
      }
    }

    fetchAllCodes()
  }, [])

  if (loading) {
    return (
      <div style={{ padding: '2rem', fontFamily: 'sans-serif' }}>
        <h1 style={{ marginBottom: '1rem' }}>Temporary Credentials</h1>
        <p>Loading credentials...</p>
      </div>
    )
  }
  return (
    <div style={{ padding: '2rem', fontFamily: 'sans-serif' }}>
      <h1 style={{ marginBottom: '1rem' }}>Temporary Credentials</h1>

      {error && (
        <div
          style={{
            padding: '1rem',
            marginBottom: '1rem',
            backgroundColor: '#fee',
            border: '1px solid #fcc',
            borderRadius: '4px',
            color: '#c00',
          }}
        >
          {error}
        </div>
      )}

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
          gap: '1rem',
        }}
      >
        {users.map((user) => (
          <a
            key={user.userId}
            href={`${baseUrl}/?userId=${user.userId}&code=${user.code}`}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '0.75rem 1rem',
              borderRadius: '8px',
              border: '1px solid #ccc',
              background: user.code ? '#f9f9f9' : '#fff5f5',
              textDecoration: 'none',
              color: '#333',
              fontWeight: 500,
              transition: 'all 0.2s',
              pointerEvents: user.code ? 'auto' : 'none',
            }}
            onMouseEnter={(e) => {
              (e.currentTarget as HTMLAnchorElement).style.backgroundColor = '#e0e0e0';
            }}
            onMouseLeave={(e) => {
              (e.currentTarget as HTMLAnchorElement).style.backgroundColor = '#f9f9f9';
            }}
          >
            <span>{user.name}</span>
            <span
              style={{
                padding: '0.25rem 0.5rem',
                borderRadius: '4px',
                fontSize: '0.75rem',
                fontWeight: 600,
                backgroundColor: roleColors[user.role]?.split(' ')[0] || '#ddd',
                color: roleColors[user.role]?.split(' ')[1] || '#333',
              }}
            >
              {user.role}
            </span>
          </a>
        ))}
      </div>
      <p style={{ marginTop: '1rem', color: 'gray' }}>
        Links dynamically use the current frontend environment.
      </p>
    </div>
  );
};